module.exports = __webpack_public_path__ + "img/2.09bb3c1b.jpg";